var _style, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 70.6",
    style: {
      enableBackground: "new 0 0 64 70.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#A8A8A8;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#A8A8A8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    className: "st0",
    d: "M38.9,68.4H2.5V2.1h53.4v43.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    className: "st1",
    d: "M42.2,16.8H16.3c-1.6,0-2.9,1.3-2.9,2.9c0,1.6,1.3,2.9,2.9,2.9l0,0h25.9c1.6,0,2.9-1.3,2.9-2.9 C45.1,18.1,43.8,16.8,42.2,16.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    className: "st1",
    d: "M42.2,32.1H16.3c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9c0,0,0,0,0,0h25.9c1.6,0,2.9-1.3,2.9-2.9 S43.8,32.1,42.2,32.1C42.2,32.1,42.2,32.1,42.2,32.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    className: "st1",
    d: "M42.2,48.5H16.3c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9c0,0,0,0,0,0h25.9c1.6,0,2.9-1.3,2.9-2.9 S43.8,48.5,42.2,48.5C42.2,48.5,42.2,48.5,42.2,48.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_449_1_",
    className: "st1",
    d: "M59.5,62.1l3.7-3.6c1.1-1.1,1.1-2.9,0-4c-1.1-1.1-2.8-1.1-3.9,0l-3.7,3.7l-3.7-3.7 c-1.1-1.1-2.9-1.1-4,0c-1.1,1.1-1.1,2.9,0,4l3.7,3.6l-3.7,3.6c-1.1,1.1-1.1,2.9,0,4c1.1,1.1,2.9,1.1,4,0l0,0l3.7-3.7l3.7,3.7 c1.1,1.1,2.9,1.1,4,0c1.1-1.1,1.1-2.9,0-4l0,0L59.5,62.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.914e29fd9a6a4334673266ae0540ea7b.svg";
export { ForwardRef as ReactComponent };